import { type FC, type PropsWithChildren } from 'react';
import { Indicator } from '@mantine/core';
import { useUnit } from 'effector-react';
import { $payinNewOrdersCount } from '../model';

export const NewOrdersCount: FC<PropsWithChildren> = ({ children }) => {
    const count = useUnit($payinNewOrdersCount);

    if (!count || count === 0) {
        return children;
    }

    return (
        <Indicator
            w='100%'
            withBorder
            offset={3}
            size={24}
            color='red'
            label={count}
        >
            {children}
        </Indicator>
    );
};
